import * as React from 'react'

const SvgUpIcon = (props) => (
  <svg
    width="14"
    height="9"
    viewBox="0 0 14 9"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11 6.5L6 1.5L1 6.5"
      stroke="#B3B8DB"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default SvgUpIcon
